const breadCrumb = "Lançamento de Notas - Lançamento de Notas/Conceitos/Faltas";

const routes = [
  {
    path: "/lancar-nota-recuperacao-final-turma",
    name: "lancar-nota-recuperacao-final-turma",
    meta: {
      allowedPermissions: ["lancamento_nota_recuperacao_final_turma_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancarNotaRecuperacaoFinalTurma/PermitirLancarNotaRecuperacaoFinalTurmaHome.vue"
      ),
  },
  {
    path: "/lancar-nota-recuperacao-final-disciplina/:disciplinaArea",
    name: "lancar-nota-recuperacao-final-turma-disciplina",
    meta: {
      allowedPermissions: [
        "alunos_avaliacao_turma_notas_create",
        "alunos_avaliacao_turma_notas",
      ],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancarNotaRecuperacaoFinalTurma/LancarNotaRecuperacaoFinalTurma.vue"
      ),
  },
];

export default routes;
